/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
import React from "react";
import { useNavigate } from "react-router-dom";

import MenuItem from "@mui/material/MenuItem";
import { Action } from "pages/dashboard/interests-profile/components/reason-modal";
import { toKabobCase } from "pages/dashboard/interests/utils";


// Used for sending the navigation state to the routes. By using an index and incrementing before
// we send, we can ensure subsequent clicks of the "Add Document" or other actions action
// are able to be responded to in the route handler.
let addDocumentIndex = 1;
let logCallIndex = 1;
let addNoteIndex = 1;
let sendMessageIndex = 1;

const displayButtonName = (action: Action): string => ({
  "Add Document": "Add Document",
  "Add Note": "Add Note",
  "Change Status": "Change Status",
  "Log Call": "Log Call",
  "Moved In": "Move In",
  "On Waitlist": "Reinstate",
  "Removed": "Remove",
  "Reset Password": "Reset Password",
  "Request Forms": "Request Forms",
  "Send Full Application": "Send Full Application",
  "Send Message": "Send Message",
  "Skip": "Skip",
  "Sync with OneSite": "Sync with OneSite",
}[action] || "");

const navigateRelative = (
  navigateFn: ReturnType<typeof useNavigate>,
  relativePath: string,
  state: Record<string, unknown>,
) => {
  navigateFn(relativePath, { relative: "path", state });
};

type ActionItemProps = {
  action: Action;
  setActions: {
    setIsSendFullAppOpen: (open: boolean) => void;
    setConfirming: (action: Action | null) => void;
    setBatchActionsModalFocusedAction: (action: Action) => void;
    setIsRequestFormsOpen: (open: boolean) => void;
    setIsResetPasswordFormOpen: (open: boolean) => void;
  };
  closeModal: () => void;
}
const ActionItem: React.FC<ActionItemProps> = ({ action, setActions, closeModal }) => {
  const navigate = useNavigate();
  const {
    setIsSendFullAppOpen,
    setConfirming,
    setBatchActionsModalFocusedAction,
    setIsRequestFormsOpen,
    setIsResetPasswordFormOpen,
  } = setActions;
  return (
    <MenuItem
      id={`slideout-actions-${toKabobCase(action)}`}
      onClick={() => {
        switch (action) {
          case "Send Full Application":
            setIsSendFullAppOpen(true);
            break;
          case "Request Forms":
            setIsRequestFormsOpen(true);
            break;
          case "Moved In":
          case "Removed":
          case "On Waitlist": {
            setConfirming(action);
            break;
          }
          case "Skip": {
            setConfirming(action);
            break;
          }
          case "Add Document": {
            navigateRelative(navigate, "../documents", { addDocumentIndex });
            // increment index so next time we click the button, it will correctly trigger upload
            // even if we're already on the route we navigated to above
            addDocumentIndex += 1;
            break;
          }
          case "Log Call": {
            navigateRelative(navigate, "../activity", { logCallIndex });
            // increment index so next time we click the button, it will correctly trigger upload
            // even if we're already on the route we navigated to above
            logCallIndex += 1;
            setBatchActionsModalFocusedAction(Action.LogCall);
            break;
          }
          case "Add Note": {
            navigateRelative(navigate, "../activity", { addNoteIndex });
            // increment index so next time we click the button, it will correctly trigger upload
            // even if we're already on the route we navigated to above
            addNoteIndex += 1;
            setBatchActionsModalFocusedAction(Action.AddNote);
            break;
          }
          case "Reset Password": {
            setIsResetPasswordFormOpen(true);
            break;
          }
          case "Send Message": {
            navigateRelative(navigate, "../activity", { sendMessageIndex });
            // increment index so next time we click the button, it will correctly trigger upload
            // even if we're already on the route we navigated to above
            sendMessageIndex += 1;
            setBatchActionsModalFocusedAction(Action.SendMessage);
            break;
          }
          case "Sync with OneSite": {
            setConfirming(action);
            break;
          }

          default:
            break;
        }
        closeModal();
      }}
    >
      {displayButtonName(action)}
    </MenuItem>
  );
};


export default ActionItem;
